import { Badge, Space } from "antd";
import { Button } from "antd";
// import { PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { docLinkRender } from "../../../components/table/DocLink";
// import dayjs from 'dayjs';

export const accessColumn = ({ handleEdit, handleDelete, handleView }) => [
  {
    title: "id",
    key: "id",
    dataIndex: "id",
    align: "left",
    hidden: true,
  },
  {
    title: "Packaging Code",
    dataIndex: "pk_code",
    key: "pk_code",
    width: "20%",
    sorter: (a, b) => (a?.pk_code || "").localeCompare(b?.pk_code || ""),
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดูข้อมูลบรรจุภัณฑ์"),
  },
  {
    title: "Packaging Name",
    dataIndex: "pk_name",
    key: "pk_name",
    width: "50%",
    sorter: (a, b) => (a?.pk_name || "").localeCompare(b?.pk_name || ""),
  },
  {
    title: "Packaging Type",
    dataIndex: "pktype_name",
    key: "pktype_name",
    width: "20%",
    sorter: (a, b) => (a?.pktype_name || "").localeCompare(b?.pktype_name || ""),
  },
  {
    title: "สถานะ",
    dataIndex: "active_status",
    key: "active_status",
    width: "10%",
    sorter: (a, b) => (a?.active_status || "").localeCompare(b?.active_status || ""),
    /* รองรับข้อมูลเก่าที่เคยเก็บเป็น Y/N และแถวที่ยังไม่เคยตั้งค่า */
    render: (data) => {
      const isOff = data === "ปิดการใช้งาน" || data === "N";
      return (
        <div>
          {isOff ? (
            <Badge status="error" text="ปิดการใช้งาน" />
          ) : (
            <Badge status="success" text="เปิดการใช้งาน" />
          )}
        </div>
      );
    },
  },
  {
    title: "Action",
    key: "operation",
    width: 140,
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(record)}
        />
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
      </Space>
    ),
  },
];


// export const volumelist = [
//   { value:"100", label: "100 ml." },
//   { value:"200", label: "200 ml." },
//   { value:"500", label: "500 ml." },
//   { value:"1000", label: "1,000 ml." },
// ];
